<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'>حركة المخزن</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
              هنا يتم عرض حركة أصناف المخزن بين تاريخين
            </div>
            <!-- /.panel-heading -->
            <div class='panel-body'>
              <div class='alert alert-danger alert-dismissable' v-if='mainValidationErrors'>
                <ul v-if='mainValidationErrors'>
                  <li v-for='err in mainValidationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class='form-group col-lg-3 col-md-6 col-sm-6'>
                <label>الفرع:</label>
                <select @change='changeBranch()' class="form-control" v-model="branch">
                  <option v-for="item in branches" :key="item.id" v-bind:value="item.id">
                    {{ item.name }}
                  </option>
                </select>
              </div>
              <div class='form-group col-lg-3 col-md-6 col-sm-6'>
                <label>المخزن:</label>
                <select  class="form-control" v-model="store_id">
                  <option v-for="item in stores" :key="item.id" v-bind:value="item.id">
                    {{ item.name }}
                  </option>
                </select>
              </div>
              <div class='form-group col-lg-3 col-md-6 col-sm-6'>
                <tbDate  :mytitle='fromTitle' v-model= 'date_from' ></tbDate>
              </div>
              <div class='form-group col-lg-3 col-md-6 col-sm-6'>
                <tbDate  :mytitle='toTitle' v-model= 'date_to' ></tbDate>
              </div>
              <div class='form-group col-lg-12 col-md-12 col-sm-12'>
                <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-md btn-block'>عرض</button>
              </div>
              <!-- /.panel-heading -->
              <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                <thead>
                  <tr>
                    <th style='text-align: center'>م</th>
                    <th style='text-align: center'>الصنف</th>
                    <th style='text-align: center'>رصيد أول المدة</th>
                    <th style='text-align: center'>الوارد</th>
                    <th style='text-align: center'>الصادر</th>
                    <th style='text-align: center'>رصيد آخر المدة</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class='odd gradeX' v-for='(record, index) in records' :key='record.id'>

                    <td align='center'>{{index+1}}</td>
                    <td align='center'>{{record.item}}</td>
                    <td align='center'>{{record.amuntat}}</td>
                    <td align='center'>{{record.amuntin}}</td>
                    <td align='center'>{{record.amuntout}}</td>
                    <td align='center'>{{record.quantity}}</td>
                  </tr>
                </tbody>
              </table>
              <!-- /.table-responsive -->
            </div>
            <!-- /.panel-body -->
          </div>
          <!-- /.panel -->
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
  </div>
  <!-- /.container-fluid -->
</template>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  components: {
    tbDate
  },
  name: 'StockMovementRep',
  data () {
    return {
      fromTitle: 'من',
      toTitle: 'إلى',
      date_from: '',
      date_to: '',
      mainValidationErrors: '',
      records: {},
      branches: [],
      stores: [],
      store_id: '',
      branch: '',
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      title: ''
    }
  },
  created () {
    this.branch = localStorage.getItem('BrancheID')
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.changeBranch()
  },
  methods: {
    changeBranch () {
      let i = this.branches.findIndex(x => x.id === parseInt(this.branch))
      if (i > -1) {
        this.stores = this.branches[i].stores
      }
    },
    changerecStore () {
      this.store_id = this.record.store_id
      this.GetData()
    },
    GetData () {
      this.mainValidationErrors = ''
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getstockmovementrep', {
        token: localStorage.getItem('token'),
        store_id: this.store_id,
        date_from: this.date_from,
        date_to: this.date_to
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.mainValidationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/purchases/StockMovementRep.vue